import React, { useState } from 'react';
import { SeoTestDetails } from '../types';
import { Button, Modal } from 'antd';
import '../FailedChecks.less';


type Props = {
    seoTestDetails: SeoTestDetails;
};


export default function FailedCheckDescription({ seoTestDetails }: Props) {
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

    const handleToggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    return (
        <div className="failed-check-description">
            <div
                className="description-content"
                dangerouslySetInnerHTML={{ __html: seoTestDetails.recommendation }}
            />
            {seoTestDetails.how_to_fix && (
                <div className="description-meta">
                    <Button
                        type="danger"
                        onClick={handleToggleModal}
                    >
                        How to fix
                    </Button>
                    <Modal
                        centered
                        className="wide-modal"
                        title={seoTestDetails.title}
                        visible={isModalVisible}
                        onCancel={handleToggleModal}
                        footer={null}
                    >
                        <div className="modal-content no-padding">
                            {seoTestDetails.how_to_fix.video && (
                                <iframe
                                    title="video"
                                    width="100%"
                                    height="320"
                                    src={seoTestDetails.how_to_fix.video}
                                    frameBorder={0}
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            )}
                            <div className="default-padding how-to-fix-content">
                                <h3>How to pass this test?</h3>
                                <span dangerouslySetInnerHTML={{ __html: seoTestDetails.how_to_fix.html }} />
                            </div>
                        </div>
                        <div className="button-footer">
                            <Button onClick={handleToggleModal}>Close</Button>
                        </div>
                    </Modal>
                </div>
            )}
        </div>
    );
}
